import { DateTime } from 'luxon';
import { createSelector } from 'reselect';

import {
  constructPredefinedInterval,
  getStartOfToday,
  type PredefinedRange,
} from 'app-components/utils/date/predefinedRange';
import type RootState from 'app-components/utils/redux-store/rootState';

import { DATE_REDUCER_KEY } from './dateTypes';

export const getDateStore = (state: Pick<RootState, DATE_REDUCER_KEY>) => state[DATE_REDUCER_KEY];
export const getCurrentDateString = createSelector(getDateStore, (store) => store.currentDate);

export const getCurrentDate = createSelector(getCurrentDateString, (dateString) => DateTime.fromISO(dateString));

export const getPredefinedInterval = createSelector(
  (_state: unknown, range: PredefinedRange) => range,
  getCurrentDate,
  constructPredefinedInterval,
);

export const getStartOfMonthDate = createSelector(getCurrentDateString, (today) => `${today.slice(0, 7)}-01`);

export const startOfTodaySelector = createSelector(getCurrentDate, getStartOfToday);
